import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';


@Injectable({
  providedIn: 'root'
})
export class CustomerHierarchyService {
  public assignedCustomerData = new BehaviorSubject<any>(false);
  assignedCustomerData$ = this.assignedCustomerData.asObservable();
  public assignedApproverData = new BehaviorSubject<any>(false);
  assignedApproverData$ = this.assignedApproverData.asObservable();
  baseUrl: string;

  constructor(private baseService: BaseService, private http: HttpClient, private occEndpointService: OccEndpointsService) {
    this.baseUrl = this.occEndpointService.getBaseUrl();
  }

  createUpdateNode(action: string, params): Observable<any> {

    let url = '/my-company/customer-hierarchy/create-node';
    return action === 'create' ? this.baseService.post(url, params) :
      this.http.patch(`${this.baseUrl}${url}?nodeId=${params['nodeId']}&updatedName=${params['updatedName']}`, null, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        observe: 'response'
      });
  }
  getNodeHierarchy(params): Observable<any> {

    return this.baseService.get(`/my-company/customer-hierarchy/view-customer-hierarchy`, params);
  }
  assignedCustomer(params) {
    this.assignedCustomerData.next(false);
    this.baseService.get(`/my-company/customer-hierarchy/view-assigned-customer`, params).subscribe((res) => {
      this.assignedCustomerData.next(res);
    });
  }
  assignedApprover(params) {
    this.assignedApproverData.next(false);
    this.baseService.get(`/my-company/customer-hierarchy/view-assigned-approvers`, params).subscribe((res) => {
      this.assignedApproverData.next(res);
    });
  }
  getValidCustomers(params): Observable<any> {
    return this.baseService.get(`/my-company/customer-hierarchy/valid-customers`, params);
  }
  getSearchCustomers(params): Observable<any> {
    return this.baseService.get(`/my-company/customer-hierarchy/search-customers`, params);
  }
  addCustomer(params): Observable<any> {
    return this.baseService.get(`/my-company/customer-hierarchy/assign-cust-to-node`, params);
  }
  removeCustomer(params): Observable<any> {
    return this.baseService.get(`/my-company/customer-hierarchy/remove-custs-from-node`, params);
  }
  removeChild(nodeId): Observable<any> {
    return this.http.delete(`${this.baseUrl}/my-company/customer-hierarchy/remove-node?nodeId=${nodeId}`,
    {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      observe: 'response'
    });
  }
  getSearchApprovers(params): Observable<any> {
    return this.baseService.get(`/my-company/customer-hierarchy/search-for-unassigned-contacts`, params);
  }
  addUpdateApprovers(params): Observable<any> {
    return this.baseService.post(`/my-company/customer-hierarchy/add-update-approvers`, params);
  }
  removeApprover(params): Observable<any> {
    return this.baseService.get(`/my-company/customer-hierarchy/removeApprover`, params);
  }
  removeDelegate(params): Observable<any> {
    return this.baseService.get(`/my-company/customer-hierarchy/removeDelegates`, params);
  }
}
